function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M27.21 4h102.37c11.53 0 21 8.94 15.87 21.45C157.2 39 151 49.25 151 49.25s11.11 12.06.32 23.8c2.79 7.85 4.4 14.79-5.84 21.73s-34.54.18-43.42-.91c-11.9 3.8 23.55 61.14-14.19 62.13-.16-.41-4.4 1-3.2-13.88C84.61 125.48 51 87 44 76"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M52 4H24A20 20 0 004 24v40a20 20 0 0020 20h8a20 20 0 0020-20z"
});

var SvgDislike = function SvgDislike(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "ICON",
    viewBox: "0 0 160 160",
    "aria-hidden": true
  }, props), _ref, _ref2);
};

export default SvgDislike;